module.exports = __webpack_public_path__ + "static/media/mechanic.c3ec7019.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mechanic.svg
// module id = 722
// module chunks = 0